import React from 'react';

import "./border.css"

const Border = () => {
    return (<div className="screen-borders">
        <div className="screen-border border-horizontal border-ceil"></div>
        <div className="screen-border border-left border-vertical"></div>
        <div className="screen-border border-right border-vertical"></div>
        <div className="screen-border border-horizontal border-floor"></div>
    </div>);    
};

export default Border;